import { S3_IMAGES_URL } from '../../../constants';

export const PAYMENT_OPTIONS = [
  {
    id: 1,
    src: `${S3_IMAGES_URL}payment_options/payment-01.svg`,
  },
  {
    id: 2,
    src: `${S3_IMAGES_URL}payment_options/payment-02.svg`,
  },
  {
    id: 3,
    src: `${S3_IMAGES_URL}payment_options/payment-03.svg`,
  },
  {
    id: 4,
    src: `${S3_IMAGES_URL}payment_options/payment-04.svg`,
  },
  {
    id: 5,
    src: `${S3_IMAGES_URL}payment_options/payment-05.svg`,
  },
  {
    id: 6,
    src: `${S3_IMAGES_URL}payment_options/payment-06.svg`,
  },
  {
    id: 7,
    src: `${S3_IMAGES_URL}payment_options/payment-07.svg`,
  },
  {
    id: 8,
    src: `${S3_IMAGES_URL}payment_options/payment-08.svg`,
  },
  {
    id: 9,
    src: `${S3_IMAGES_URL}payment_options/payment-09.svg`,
  },
  {
    id: 10,
    src: `${S3_IMAGES_URL}payment_options/payment-10.svg`,
  },
  {
    id: 11,
    src: `${S3_IMAGES_URL}payment_options/payment-01.svg`,
  },
  {
    id: 12,
    src: `${S3_IMAGES_URL}payment_options/payment-02.svg`,
  },
  {
    id: 13,
    src: `${S3_IMAGES_URL}payment_options/payment-03.svg`,
  },
  {
    id: 14,
    src: `${S3_IMAGES_URL}payment_options/payment-04.svg`,
  },
  {
    id: 15,
    src: `${S3_IMAGES_URL}payment_options/payment-05.svg`,
  },
  {
    id: 16,
    src: `${S3_IMAGES_URL}payment_options/payment-06.svg`,
  },
  {
    id: 17,
    src: `${S3_IMAGES_URL}payment_options/payment-07.svg`,
  },
  {
    id: 18,
    src: `${S3_IMAGES_URL}payment_options/payment-08.svg`,
  },
  {
    id: 19,
    src: `${S3_IMAGES_URL}payment_options/payment-09.svg`,
  },
  {
    id: 20,
    src: `${S3_IMAGES_URL}payment_options/payment-10.svg`,
  },
];
